import { CalendarPicker } from "@mui/lab";
import React from "react";
import styles from "./PreviousSales.module.scss";
// import { Calendar } from "react-date-range";

import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";

import DatePicker from "@mui/lab/DatePicker";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { Button } from "@mui/material";
import FilterListIcon from "@material-ui/icons/FilterList";

interface IProps {
  onClose: () => void;
}

const PreviousSales: React.FC<IProps> = ({ onClose }) => {
  const [filterDateValue, setFilterDateValue] = React.useState<Date | null>(
    new Date()
  );

  const handleDateFilterChange = (newValue: Date | null) => {
    setFilterDateValue(newValue);
  };

  const handleFiltering = () => {
    console.log("filterDateValue");
    window.alert(filterDateValue);
  };
  return (
    <div className={styles.overlay_model}>
      <div className={styles.success_model}>
        <div className={styles.filter_header}>
          {/* <span>Select from:</span>
          <input type="date" /> */}
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            {/* <Stack spacing={3}> */}
            <DatePicker
              disableFuture
              label="Filter By Date"
              inputFormat="MM/dd/yyyy"
              value={filterDateValue}
              onChange={handleDateFilterChange}
              renderInput={(params) => <TextField {...params} />}
            />
            {/* </Stack> */}
            <Button
              style={{ marginLeft: "10px" }}
              variant="outlined"
              startIcon={<FilterListIcon />}
              onClick={handleFiltering}
            >
              Filter
            </Button>
          </LocalizationProvider>
        </div>

        {/* <div className={styles.success_model_container}>
          <button onClick={onClose}></button>
        </div> */}
        <div className={styles.previous_sale_list}>
          {/* <span>#1111</span>
          <span>#1111</span>
          <span>#1111</span>
          <span>#1111</span>
          <span>#1111</span>
          <span>#1111</span>
          <span>#1111</span>
          <span>#1111</span>
          <span>#1111</span>
          <span>#1111</span> */}
          <span>
            previous sales should be fetched from the backend and displayed
            here.
          </span>
        </div>

        <div className={styles.footer}>
          <button onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default PreviousSales;
